import { render, staticRenderFns } from "./ProductBasePage.vue?vue&type=template&id=56691836&"
import script from "./ProductBasePage.vue?vue&type=script&lang=js&"
export * from "./ProductBasePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports